import React from 'react';

export const DropDownButtonActionRender = (props) => {
    return (
        <div className="drop-down-button-item">
            {props.item.name}
        </div>
    );
}
